export const listMessages = `
   query listMessages($filter: MessagesFilterInput, $limit: Int, $nextToken: String) {
       listMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              messageId
              from
              fromText
              fromHtml
              to
              toText
              toHtml
              subject
              date
              parsedPath
              parsedObjectKey
              htmlPath
              htmlObjectKey
              textPath
              textObjectKey
              textAsHtmlPath
              textAsHtmlObjectKey
              attachments {
                  filename
                  filePath
                  objectKey
              }
              aliasId
              tagIds
              tags {
                    items {
                      id
                      name
                  }
              }
              status
              inReplyTo
              createdByUsername
              managedByUsername
              created
              updated
           }
           nextToken
       }
   }
`;

export const getMessage = `
   query getMessage($id:ID!) {
       getMessage(id:$id) {
         id
         messageId
         from
         fromText
         fromHtml
         to
         toText
         toHtml
         subject
         date,
         parsedPath
         parsedObjectKey
         htmlPath
         htmlObjectKey
         textPath
         textObjectKey
         textAsHtmlPath
         textAsHtmlObjectKey
         attachments {
          filename
          filePath
          objectKey
         }
         aliasId
         tagIds
         tags {
             items {
                  id
                  name
             }
         }
         status
         inReplyTo
         createdByUsername
         managedByUsername
         created
         updated
       } 
}`;
